import React, { useState, useEffect } from 'react';
import tenorService from '../services/tenorService';
import '../styles/GifPicker.css';

const GifPicker = ({ onGifSelect, isVisible }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [gifs, setGifs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isVisible) {
      loadFeaturedGifs();
    }
  }, [isVisible]);

  const loadFeaturedGifs = async () => {
    setIsLoading(true);
    try {
      const featuredGifs = await tenorService.getFeaturedGifs();
      setGifs(featuredGifs);
    } catch (error) {
      console.error('Error loading featured GIFs:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!searchTerm.trim()) {
      loadFeaturedGifs();
      return;
    }

    setIsLoading(true);
    try {
      const searchResults = await tenorService.searchGifs(searchTerm);
      setGifs(searchResults);
    } catch (error) {
      console.error('Error searching GIFs:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGifClick = (gif) => {
    onGifSelect({
      url: gif.url,
      title: gif.title,
      id: gif.id
    });
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="gif-picker">
      <div className="gif-picker-header">
        <h3>Choose a GIF</h3>
      </div>

      <form className="gif-search-form" onSubmit={handleSearch}>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search for GIFs... (leave empty for featured GIFs)"
          className="gif-search-input"
        />
        <button type="submit" className="gif-search-button">
          {searchTerm ? 'Search' : 'Featured'}
        </button>
      </form>

      <div className="gif-grid">
        {isLoading ? (
          <div className="gif-loading">Loading GIFs...</div>
        ) : gifs.length > 0 ? (
          gifs.map((gif) => (
            <div 
              key={gif.id} 
              className="gif-item"
              onClick={() => handleGifClick(gif)}
            >
              <img 
                src={gif.thumbnail} 
                alt={gif.title}
                loading="lazy"
              />
            </div>
          ))
        ) : (
          <div className="no-gifs">No GIFs found</div>
        )}
      </div>

      <div className="gif-picker-footer">
        <p className="powered-by">Powered by Tenor</p>
      </div>
    </div>
  );
};

export default GifPicker;